{#if isEditMode}
    <CourseInfoBoxEditView
        {antiForgeryHeaderName}
        {antiForgeryHeaderValue}
        {canAdminGeneral}
        {courseDescription}
        {courseUrl}
        {displayShowTeachers}
        {i18n}
        {showTeachers}
        {updateCourseInfoBoxSettingsEndpointURL}
    />
{:else}
    <CourseInfoBoxReadView
        {canAdminGeneral}
        {courseColour}
        {courseDescription}
        {courseTitle}
        {courseImageDescription}
        {courseImageUrl}
        {editPageUrl}
        {i18n}
        showTeachers={displayShowTeachers && showTeachers}
        {teachers}
    >
        <slot name="custom" slot="custom" />
    </CourseInfoBoxReadView>
{/if}

<script>
    import CourseInfoBoxEditView from "./CourseInfoBoxEditView.svelte";
    import CourseInfoBoxReadView from "./CourseInfoBoxReadView.svelte";

    export let antiForgeryHeaderName;
    export let antiForgeryHeaderValue;
    export let canAdminGeneral;
    export let courseColour;
    export let courseDescription;
    export let courseTitle;
    export let courseImageDescription;
    export let courseImageUrl;
    export let courseUrl;
    export let displayShowTeachers;
    export let editPageUrl;
    export let i18n;
    export let isEditMode;
    export let showTeachers;
    export let teachers;
    export let updateCourseInfoBoxSettingsEndpointURL;
</script>
